import { AxiosResponse } from "axios";
import {
    CipPostResult
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { Location } from "vue-router";
import router from "@/employee/routes";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";

export const shouldUserClaimMigratedAccount = (e: AxiosResponse<CipPostResult>) =>
    e && e.status === 400 && e.data && e.data.isReadyToClaimMigrationMatch;

const userCanClaimMigratedAccountText =
    "Good news! It seems you have an existing account with PilotHSA or Paragon. " +
    "That means getting setup with Bend is even easier.  We’ve filled in the information below based " +
    "on what you’ve told us. Please confirm this is correct and create a new password to complete " +
    "the activation process. If this seems incorrect, please call us at 877-201-3235.";

const showClaimReadyMigrationAccountError = () => {
    const notifierStore = useNotifierStore();
    return notifierStore.setSuccess(userCanClaimMigratedAccountText);
};

export const changeToClaimMigrationAccount = (partnerId?: number): Promise<void> => {

    const enrollmentStore = useEnrollmentStore();
    const previouslyEnteredPii = enrollmentStore
        ? enrollmentStore.previouslyEnteredPii
        : null;

    const userStore = useUserStore();
    return userStore.logout()
        .then(() => {
            // we have to set this again, after the logout since logging out clears most of the vuex tree
            enrollmentStore.setPreviouslyEnteredPii(previouslyEnteredPii);
            showClaimReadyMigrationAccountError();
        })
        // display the message to the user to explain what happened
        .then(() => showClaimReadyMigrationAccountError())
        .catch(error => {
            return storeHelper.handleError({ error, rethrow: true });
        });
};
